// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AndroidOutlinedSvg from "@ant-design/icons-svg/es/asn/AndroidOutlined";
import AntdIcon from '../components/AntdIcon';

var AndroidOutlined = function AndroidOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AndroidOutlinedSvg
  }));
};

AndroidOutlined.displayName = 'AndroidOutlined';
export default React.forwardRef(AndroidOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AndroidOutlined.js
// module id = 565
// module chunks = 0